import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import viewRelatedSpaceThirdParty from './viewRelatedSpaceThirdParty';

export default {
  title: 'Basic Details',
  attributeName: 'space',
  fields: [
    {
      attributeName: 'mainHubId',
      helpText: 'Id of the video.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'ID',
      placeholder: 'Video name...',
      hidden: true
    },
    {
      attributeName: 'spaceId',
      helpText: 'Id of the video.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'ID',
      placeholder: 'Video name...',
    },
    {
      attributeName: 'name',
      helpText: 'Application of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Space Name',
      placeholder: 'Application...',
      disabled: true
    },
    {
      attributeName: 'totalContents',
      helpText: 'Total number of contents visible on the space',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Total contents visible',
      placeholder: 'Total contents...',
      disabled: true
    },
    {
      attributeName: 'blockingProviders',
      label: 'Blocking Provider',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      configFile: viewRelatedSpaceThirdParty,
      default: [],
      helpText: 'Select the authentication provider required to access this MainHub.',
      exactWidth: '10rem',
    },
    {
      attributeName: 'posterLogo',
      helpText: 'Poster logo used in the logo hierarchy fallback',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Poster Logo',
      hasSelect:false,
      fileType: ['image/*'],
      allowedSizes: [
        { width: 128, height: 128 },
        { width: 192, height: 128 },
      ],
    },
    {
      attributeName: 'hideAppPosterLogo',
      helpText: 'Prevent fallback to App logo',
      type: FormInputTypes.CHECKBOX,
      label: 'Hide App Logo',
    },
  ],
};
